module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2645790472/src/~/core-js/library/modules/_redefine.js
// module id = L1xW
// module chunks = 6